module.exports = __webpack_public_path__ + "static/img/kyocera.2b1960a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kyocera.jpg
// module id = e3Dh
// module chunks = 1